import YourCredits from "./your-credits";

export default YourCredits;
